var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPullOverIcon = function SvgPullOverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 134,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3FFE6",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M91.385 58.612c.021 4.911.413 10.705 4.944 15.272l19.765 19.92c7.577 7.636 7.906 17.264 7.906 21.248V128h-19.765v-10.292c0-5.644-2.306-10.624-7.906-16.268L81.177 86.168c-7.906-7.968-9.883-13.28-9.883-22.244v-5.312H68L81.506 45l13.506 13.612h-3.624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M86 5v5.843a4 4 0 0 1-1.172 2.829L61.172 37.328A4 4 0 0 0 60 40.157v46.686a4 4 0 0 0 1.172 2.829l23.656 23.656A4 4 0 0 1 86 116.157V128"
  })));
};
export default SvgPullOverIcon;